import { useEffect, useState } from "react";
import { readBar, subscribeBar } from "../utils/chordBarsClipboard";

// The bar waiting to be pasted, `{ cell, beatsPerBar }` or null, kept current when a copy is made elsewhere
const useCopiedBar = () => {
  const [bar, setBar] = useState(readBar);

  useEffect(() => subscribeBar(setBar), []);

  return bar;
};

export default useCopiedBar;
